import Model, { attr } from '@ember-data/model';

export default class PartnerApiKeyModel extends Model {
  @attr('string') apiKey!: string;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'partner-api-key': PartnerApiKeyModel;
  }
}
